<br />
<div class="container">
  <div class="row" *ngIf="error">
    <div class="col-sm-12">
      <div class="alert alert-danger">
        <h3>{{messageTitle}}</h3>
        <p class="lead">
          {{messageText}}<br /><br />
          <button class="btn btn-default" onclick="window.history.back()">{{'Back' | translate}}</button>
        </p>
      </div>
    </div>
  </div>
  <div id="pageLoaderDiv" class="page-loader" *ngIf="!error">
    <div class="centered-div-outer">
      <div class="centered-div-middle">
        <div class="centered-div-inner opening-page">
          <div class="loadingFileSpinner"></div>
          <div>{{'OpeningPage' | translate}}…</div>
        </div>
      </div>
    </div>
  </div>
</div>
